import React from "react";
import { useParams } from "react-router-dom";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useUserInfo from "../../hooks/queryResults/useUserInfo";
import useCurrentUser from "../../hooks/useCurrentUser";
import Loading from "../ui/Loading";

const UserHome = () => {
  const { username } = useParams();
  const currentUser = useCurrentUser();
  const { userInfo: userInfoData, userInfoQuery } = useUserInfo();

  const isLoading = useIsLoading(userInfoData, userInfoQuery);
  if (isLoading) return <Loading />;

  console.log("userInfo", userInfoData);

  // let user = null;
  if (userInfoData.data.user.username === username && currentUser.isLoggedIn) {
    // this is the page of the logged in user
    // user = userInfo.data.user;
  } else {
    // this is the page of another user
  }

  // todo: show all the user's leagues and league seasons
  // todo: provide links to edit leagues, invite users, etc
  // todo: show all the user's franchises and teams
  // todo: provide links to create a new league
  // todo: provide links to create a new team etc

  return (
    <div>
      <h1>User Home - {username}</h1>
      <p>
        Sorry, this section is not ready yet, but much more will be added here
        very soon!
      </p>
    </div>
  );
};

export default UserHome;
